<div class="sidebar included">
	<app-sidebar-header [title]="INDRA_getGroupLabel()"></app-sidebar-header>
	<div class="sidebar__body sl--scrollable" #sidebar__body>
		<app-flight-route [flight]="flightRouteInput"></app-flight-route>
		<div class="sidebar__header-image" [style.background-image]="INDRA_printImage()"></div>

		<div class="sidebar__info--flight-info top-gap" *ngIf="!directFlight && stops.length">
			<p>{{ 'whatsIncludedSidebars.text.thisTripHas' | ibeadmin: 'sync'  }} {{ stops.length }} {{ 'whatsIncludedSidebars.text.flights' | ibeadmin: 'sync' }}. {{ 'whatsIncludedSidebars.detailsFastTrack.text.chooseForFastTrackInfo' | ibeadmin: 'sync' }}</p>
			<app-segmented-control-radio classes="sidebar__info--flight-info--options" (selected)="INDRA_selectedStop($event)"
				[_value]="selectedStop" [options]="stops">
			</app-segmented-control-radio>
		</div>

		<div class="sidebar-flight-text">
			<ng-container *ngIf="INDRA_isEligibleWithFastTrack(), else noAncillary">
				<h2 class="title-h2">{{ INDRA_getTranslationKey('fastTrackPerPassenger','title') | ibeadmin:'sync' }}</h2>
				<ng-container *ngFor="let statusCode of ancillaryCartService.INDRA_getAllWarnings(flight.idFlight.toString(), ancillaryGroup)">
					<app-notification [style]="'alert'" [close]="true" [icon]="'icons.svg#airport--delays'" [classes]="'alert-sidebar top-gap bottom-gap'"
					 [title]=" INDRA_getGroupLabel() + ' ' + ('whatsIncludedSidebars.general.texts.is' | ibeadmin:'sync')
					 + ' ' + (ancillaryCartService.INDRA_getStatusKey(statusCode)| ibeadmin:'sync') + ' ' + ('whatsIncludedSidebars.general.texts.inThisFlight' | ibeadmin:'sync')">
						<div message><span *ngIf="statusCode !== 46">{{'whatsIncludedSidebars.general.texts.useInAnotherFlight' | ibeadmin:'sync'}}</span>
							<a class="link" href="{{'whatsIncludedSidebars.general.texts.contactLink' | ibeadmin:'sync'}}" target="_blank" [attr.aria-label]="INDRA_getTranslationKey('goRefund','aria') | ibeadmin:'sync'">
								{{'whatsIncludedSidebars.general.texts.contactTap' | ibeadmin:'sync'}}
							</a>
							{{'whatsIncludedSidebars.general.texts.moreInfo' | ibeadmin:'sync'}}
						</div>
					</app-notification>
				</ng-container>
				<div *ngFor="let passenger of passengers" class="border sidebar-flight-text">
					<!-- fare related ancillaries for the passenger-->
					<div *ngIf="INDRA_getAncillaryForPassenger(paxFareInfoFeatures, passenger.idPax).length > 0" class="grid no-padding">
						<div class="col-4 col-tp-4 col-p-12 no-padding">
							<p class="bold">{{INDRA_printPassengerName(passenger)}}</p>
						</div>
						<div class="col-8 col-tp-8 col-p-12">
							<p class="">
								<app-svg class="list--checked__icon" svg="sprite.svg#misc--check" 
									aria-hidden="true" [alt]="'Checked icon'">
								</app-svg>
								<span class="bold">
									{{ INDRA_getTranslationKey('at','text') | ibeadmin:'sync' }} {{ departureLocation }} {{ INDRA_getTranslationKey('airport','text') | ibeadmin:'sync' }}
								</span>
								{{ INDRA_getTranslationKey('includedIn','text') | ibeadmin:'sync' }} {{INDRA_printBrand()}}.
							</p>
						</div>
					</div>
					<!-- tier benefits for the passenger-->
					<div *ngIf="INDRA_getAncillaryForPassenger(paxFareInfoFeatures, passenger.idPax).length === 0 && INDRA_getAncillaryForPassenger(paxTierBenefits, passenger.idPax).length > 0" class="grid no-padding">
						<div class="col-4 col-tp-4 col-p-12 no-padding">
							<span *ngIf="INDRA_getAncillaryForPassenger(paxFareInfoFeatures, passenger.idPax).length == 0" class="bold">
								{{INDRA_printPassengerName(passenger)}}
							</span>
						</div>
						<div class="col-8 col-tp-8 col-p-12">
							<app-svg class="list--checked__icon" 
								svg="sprite.svg#misc--check" aria-hidden="true">
							</app-svg>
							<span class="bold">
								{{ INDRA_getTranslationKey('at','text') | ibeadmin:'sync' }} {{ departureLocation }} {{ INDRA_getTranslationKey('airport','text') | ibeadmin:'sync' }}
							</span>
							 {{ INDRA_getTranslationKey('isA','text') | ibeadmin:'sync' }} {{ INDRA_getPassengerTierLabel(passenger) }} {{ INDRA_getTranslationKey('benefit','text') | ibeadmin:'sync' }}.
						</div>
					</div>
					<!-- purchased ancillaries for the passenger-->
					<div *ngFor="let item of INDRA_getPurchasedAncillaryForPassenger(passenger.idPax); let i = index;" class="grid no-padding">
						<div class="col-4 col-tp-4 col-p-12 no-padding">
							<span *ngIf="i == 0 &&
								INDRA_getAncillaryForPassenger(paxFareInfoFeatures, passenger.idPax).length == 0 &&
								INDRA_getAncillaryForPassenger(paxTierBenefits, passenger.idPax).length == 0"
								class="bold">{{INDRA_printPassengerName(passenger)}}</span>
						</div>
						<div class="col-8 col-tp-8 col-p-12">
							<ng-container *ngIf="!item.unconfirmed">
								<app-svg class="list--checked__icon" svg="sprite.svg#misc--check" aria-hidden="true"></app-svg>
							</ng-container>
							<ng-container *ngIf="item.unconfirmed">
								<app-svg class="list--checked__icon" svg="sprite.svg#status--alert" aria-hidden="true"></app-svg>
							</ng-container>
							<span class="bold">{{INDRA_displaySegmentDeparture(item?.segmentId)}}</span>
							<!-- <span *ngIf="hasLayover">{{INDRA_displaySegmentInfo(item.segmentId)}}</span> -->
						</div>
					</div>
					<!-- no ancillaries for the passenger-->
					<div *ngIf="INDRA_getPurchasedAncillaryForPassenger(passenger.idPax).length == 0 &&
								INDRA_getAncillaryForPassenger(paxFareInfoFeatures, passenger.idPax).length == 0 &&
								INDRA_getAncillaryForPassenger(paxTierBenefits, passenger.idPax).length == 0"
								class="grid no-padding">
						<div class="bold col-4 col-tp-4 col-p-12 no-padding">{{INDRA_printPassengerName(passenger)}}</div>
						<div class="col-8 col-tp-8 col-p-12">{{ INDRA_getTranslationKey('notIncluded','text') | ibeadmin:'sync' }}</div>
					</div>
				</div>
			</ng-container>
			<!-- Fast Track not included notificaion -->
			<ng-template #noAncillary>
				<div class="divider"></div>
				<div class="message_box">
					<app-svg svg="icons.svg#general--information" [alt]="'Information icon'" aria-hidden="true"></app-svg>
					<p>{{ 'whatsIncludedSidebars.detailsFastTrack.text.fastTrackNotAvailable' | ibeadmin: 'sync' }}</p>
				</div>
				<div class="divider"></div>
			</ng-template>
		</div>

		<div class="sidebar-flight-text" *ngIf="!isMYB">
			<p>If some of the passengers are Miles&Go Silver or Gold members, fast track is free for them.</p>
			<p>Customers with the TAP Visa Gold and TAP Visa Platinum credit cards also have fast track free of charge. Just show the card at the airport's fast track.</p>
			<a href="javascript:;" class="link extras-feature__link link--external" aria-label="Open new window">Learn about all of your perks</a>
		</div>
		<div class="sidebar-flight-text">
			<p class="muted">{{ INDRA_getTranslationKey('fastTrackAllows','text') | ibeadmin:'sync' }}</p>
			<a (click)="INDRA_gotoURL('externalURLs.aboutFastTrack')" href="javascript:;"  class="link extras-feature__link link--external" [attr.aria-label]="INDRA_getTitleTranslation('allAboutFastTrack','aria')">{{ INDRA_getTranslationKey('allAboutFastTrack','text') | ibeadmin:'sync' }}</a>
		</div>
		<div class="sidebar-flight-text" *ngIf="!isBookingView && showAdd && !hasUMNRFlag">
			<button class="button " (click)="openFasttrackSidebar()" [attr.aria-label]="INDRA_getTitleTranslation('addFastTrack','aria')">{{ INDRA_getTranslationKey('addFastTrack','button') | ibeadmin:'sync' }}</button>
		</div>
		<div class="sidebar-flight-text" *ngIf="!isBookingView && INDRA_showUpgrade()">
			<p class="muted">{{ INDRA_getTranslationKey('upgradeFastTrackForFree','text') | ibeadmin:'sync' }}</p>
			<button class="button " (click)="INDRA_upgradeWithCash()" [attr.aria-label]="INDRA_getTitleTranslation('dialogeUpgradeToExecutive','aria')">{{ INDRA_getTranslationKey('upgrade','button') | ibeadmin:'sync' }}
			</button>
		</div>
		<div class="sidebar-flight-text border" *ngIf="!hasAllFrequentFlyerPassenger">
			<h2 class="title-h2">{{ INDRA_getTranslationKey('milesAndGo','text') | ibeadmin:'sync' }}</h2>
			<p>{{ INDRA_getTranslationKey('notAMemberYet','text') | ibeadmin:'sync' }}
				<a href="#" class="link extras-feature__link" [attr.aria-label]="INDRA_getTranslationKey('openSignUp','aria') | ibeadmin:'sync'">
					{{ INDRA_getTranslationKey('signup','button') | ibeadmin:'sync' }}
				</a> {{ INDRA_getTranslationKey('earnMiles','text') | ibeadmin:'sync' }}</p>
		</div>
		<div class="sidebar-flight-text border">
			<p>
				<a class="link extras-feature__link" [attr.aria-label]="INDRA_getTitleTranslation('closeDialog','aria')" (click)="INDRA_handleClose()">{{ INDRA_getTranslationKey('closeWindow','text') | ibeadmin:'sync' }}</a>
			</p>
		</div>
	</div>
	<div #sidebar__footer class="sidebar__footer "></div>
</div>
